import { render, staticRenderFns } from "./DashboardECommerce.vue?vue&type=template&id=9ab5eff2"
import script from "./DashboardECommerce.vue?vue&type=script&lang=js"
export * from "./DashboardECommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports